import service from '../api/connectionSftp.service';
//constants
const data = {
    entitiesBySociety: [],
    connectionSftp: [],
    createConnectionSftp: [],
    deleteConnectionSftp: [],
    updateConnectionSftp: [],
    errorConnectionSftp: ''
}
//types
const LIST_BY_SOCIETIES = 'LIST_CONNECTIONS_SFTP'
const LIST_CONNECTIONS_SFTP = 'LIST_CONNECTIONS_SFTP'
const CREATE_CONNECTIONS_SFTP = 'CREATE_CONNECTIONS_SFTP'
const DELETE_CONNECTIONS_SFTP = 'DELETE_CONNECTIONS_SFTP'
const UPDATE_CONNECTIONS_SFTP = 'UPDATE_CONNECTIONS_SFTP'
const ERROR_CONNECTIONS_SFTP = 'ERROR_CONNECTIONS_SFTP'

//reducer
export default function connectionSftp(state = data, action) {
    switch (action.type) {
        case LIST_BY_SOCIETIES:
            return { ...state, entitiesBySociety: action.payload };
        case LIST_CONNECTIONS_SFTP:
            return { ...state, connectionSftp: action.payload };
        case CREATE_CONNECTIONS_SFTP:
            return { ...state, createConnectionSftp: action.payload };
        case DELETE_CONNECTIONS_SFTP:
            return { ...state, deleteConnectionSftp: action.payload };
        case UPDATE_CONNECTIONS_SFTP:
            return { ...state, updateConnectionSftp: action.payload };
        case ERROR_CONNECTIONS_SFTP:
            return { ...state, errorConnectionSftp: action.payload };
        default:
            return { ...state };
    }
}

export const findBySocieties = (society) => async (dispatch) => {
    const response = await service.findBySociety(society, 0).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    let data = [];
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_CONNECTIONS_SFTP,
            payload: response
        });
        dispatch({
            type: LIST_BY_SOCIETIES,
            payload: []
        });
    } else {
        response.forEach((element) => {
            data.push({
                id: element.collectingEntity.id,
                value: element.code,
                label: element.name.toUpperCase()+' | '+element.code ,
            });

            
        });
        const result = data.reduce((acc,item)=>{
             
            if(!acc.some(x => x.id === item.id)){
                acc.push(item);
            }
            return acc;
          },[])
          data=result;
        dispatch({
            type: ERROR_CONNECTIONS_SFTP,
            payload: ''
        });
        dispatch({
            type: LIST_BY_SOCIETIES,
            payload: data
        });
    }
    return data;
}

export const findBy = (entity, username) => async (dispatch) => {
    const response = await service.getConnectionSftp(entity, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_CONNECTIONS_SFTP,
            payload: response
        });
        dispatch({
            type: LIST_CONNECTIONS_SFTP,
            payload: []
        });
    } else {

        dispatch({
            type: ERROR_CONNECTIONS_SFTP,
            payload: ''
        });
        dispatch({
            type: LIST_CONNECTIONS_SFTP,
            payload: response
        });
    }
    return response;
}
export const createConnectionSftp = (connectionSftp, username) => async (dispatch) => {
    const response = await service.getCreateConnectionSftp(connectionSftp, username).then((r) => { return r });
    dispatch({
        type: CREATE_CONNECTIONS_SFTP,
        payload:response
    });
    return response;
}

export const deleteConnectionSftp = (lsData, username) => async (dispatch) => {
    const response = await service.getDeleteConnectionSftp(lsData, username).then((r) => { return r });
    dispatch({
        type: DELETE_CONNECTIONS_SFTP,
        payload:response
    });
    return response;
}

export const updateConnectionSftp = (connectionSftp, username) => async (dispatch) => {
    const response = await service.getUpdateConnectionSftp(connectionSftp, username).then((r) => { return r });
    dispatch({
        type: UPDATE_CONNECTIONS_SFTP,
        payload:response
    });
    return response;
}